import React from 'react';
import './AlertBanner.scss';
import Info from '@spectrum-icons/workflow/Info';
import Alert from '@spectrum-icons/workflow/Alert';
import { Button } from '@adobe/react-spectrum';

export type AlertBannerVariant = 'neutral' | 'informative' | 'error';

interface AlertBannerProps {
  variant?: AlertBannerVariant;
  message: React.ReactNode;
  onClose: () => void;
}

export const AlertBanner: React.FC<AlertBannerProps> = ({
  variant = 'neutral',
  message,
  onClose
}) => {
  return (
    <div className={`alert-banner alert-banner--${variant}`}>
      <span className="alert-banner__icon">
        {variant === 'error' ? <Alert size="S" /> : <Info size="S" />}
      </span>
      <span className="alert-banner__content">{message}</span>
      <Button
        variant="secondary"
        isQuiet
        aria-label="Close"
        onPress={onClose}
        UNSAFE_className="alert-banner__close"
      >
        ×
      </Button>
    </div>
  );
};
